export default async function EditPlanLevelsApi(
  id,
  name,
  color,
  targetDate,
  kpi,
  target,
  description,
  tasks,
  worksheet,
  timesheet,
  planLevelAttributes,
  cascadeFromSplitPlansEnabled = false,
  plansTab = true,
  hierarchyTab = true
) {
  let res = "";
  try {
    const body = {
      id: id,
      name: name,
      color: color,
      targetDate: targetDate,
      kpi: kpi,
      target: target,
      description: description,
      tasks: tasks,
      worksheet: worksheet,
      timesheet: timesheet,
      planLevelAttributes: planLevelAttributes,
      cascadeFromSplitPlansEnabled: cascadeFromSplitPlansEnabled,
      plansTab: plansTab,
      hierarchyTab: hierarchyTab,
    };
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/plan-levels/`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error editing plan level: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
